import React from 'react';
import { Field } from 'redux-form';
import { NumberInput } from 'react-admin';

const UserFreqCap = (props) => (
  <div style={{ display: 'flex' }}>
    <div style={{ flex: 1, paddingTop: 20 }}>
      <span style={{ color: 'rgba(0, 0, 0, 0.298039)', fontSize: 16 }}>TTL Seconds</span><br />
      <Field
        component={NumberInput}
        label="Days"
        name="user_frequency_cap_attributes.days"
        source="user_frequency_cap_attributes.days" /><br />
      <Field
        component={NumberInput}
        label="Hours"
        name="user_frequency_cap_attributes.hours"
        source="user_frequency_cap_attributes.hours" /><br />
      <Field
        component={NumberInput}
        label="Minutes"
        name="user_frequency_cap_attributes.minutes"
        source="user_frequency_cap_attributes.minutes" />
    </div>
    <div style={{ flex: 1 }}>
      <Field
        component={NumberInput}
        label="Occurrences"
        name="user_frequency_cap_attributes.occurences"
        source="user_frequency_cap_attributes.occurences" />
    </div>
  </div>
);

export default UserFreqCap;



// WEBPACK FOOTER //
// ./src/views/Common/Partials/UserFreqCap.tsx